import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initModules } from './modules/registry';
import { loadFederatedModule } from './lib/useFederatedModule';
import './index.css';
// Leaflet-CSS host-global (Joerg 2026-08-11): Nach dem Federation-Split von
// plantafel liegt `import 'leaflet/dist/leaflet.css'` in TagesMapView zwar im
// plantafel-Bundle, wird aber vom @module-federation/vite-Runtime beim
// dynamischen Load NICHT ins Host-DOM injiziert. Konsequenz: die Karte in
// HomeGF (TagesKarteWidget) rendert ohne Leaflet-Regeln — Tiles positionsfehl,
// Marker/Controls kaputt. Fix: die CSS host-seitig einmalig importieren; jeder
// Federation-Remote der Leaflet nutzt erbt sie ueber das globale Stylesheet.
import 'leaflet/dist/leaflet.css';

// Federation-Resilience (2026-08-02): Wenn ein Federation-Remote 4xx/5xx liefert,
// wirft der @module-federation/vite-Runtime eine unhandled Promise-Rejection.
// Die reisst den Portal-Boot mit — auch wenn nur EIN Modul-Container down ist.
//
// Zwei-stufiges Sicherheitsnetz:
//  1. initModules() nutzt Promise.allSettled + individuelle .catch() (siehe registry.ts) —
//     verhindert dass ein Remote-Reject die anderen 10 Promises als unhandled markiert.
//  2. Dieser globale Listener fangt alle verbleibenden Chunk-Load-Rejections ab
//     (statische Federation-Imports in PortalShell/Components, die der Bundler in
//     dynamische import() umwandelt und die keinen Site-lokalen catch haben).
//
// Die App-Shell (Login, Adressbuch, Ubersicht) laeuft dann trotzdem — nur die
// Modul-Route die den defekten Remote braucht faellt aus (mit Suspense-Fallback).
window.addEventListener('unhandledrejection', (e) => {
  const r = e.reason;
  const msg = r instanceof Error ? r.message : String(r);
  const isChunkLoadError =
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Loading chunk') ||
    msg.includes('Importing a module script failed') ||
    (r && typeof r === 'object' && 'then' in (r as object)); // nested-promise-reject (Federation-Runtime)
  if (isChunkLoadError) {
    console.warn('[main] Federation-Chunk-Load-Fehler geschluckt:', msg);
    e.preventDefault();
  }
});

// 2026-08-21: Render SOFORT, Module parallel. Vorher hing createRoot() im
// .finally() HINTER initModules() — der erste Paint wartete auf alle 11
// Federation-Loads. Solange die schnell waren fiel das nicht auf; mit der
// Suspense-Treiber-Schleife (Commit 0d0ff18) wurde daraus ein schwarzes
// Fenster bis Budget-Ende. Die Self-Healing-Maschinerie (FR2-FR17) ist
// genau dafuer gebaut, dass Module NACH dem Render eintreffen: Sidebar +
// Router lauschen auf federation-module-registered und ziehen nach.
//
// Backend-Health-Watchdog (2026-08-03) — SSE-Stream fuer live rote/gruene
// Sidebar-Punkte OHNE Reload. Start erfolgt in <AuthEffects /> nachdem
// useAuth().isAuthenticated === true (siehe App.tsx). Vorher wuerde SSE
// ein 401 werfen und einen EventSource-Reconnect-Loop starten.
// Host-Federation-Bruecke (2026-08-21, FED-01): Federation-Remotes laden ihre
// Cross-Modul-Imports (z.B. zeiterfassung → bauberichteV2/public) NICHT mehr
// ueber eigene remotes-Deklarationen (verschachtelte MF-Runtime-Instanzen,
// deren Interop deterministisch klemmt), sondern ueber diese Host-Bruecke —
// der Host-Loader-Pfad ist derselbe wie bei useFederatedModule und stabil.
// Registrierung VOR dem Render, damit die Bruecke vor jedem Modul-Code da ist.
// Consumer-Seite: loadHostModule() in @onvice/portal-shell-api.
window.__onviceHostFederation = { load: loadFederatedModule };

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

void initModules().catch((err) => {
  console.error('[main] Federation-Remote-Load fehlgeschlagen:', err);
});
